import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { NzMessageService } from 'ng-zorro-antd/message';
import { differenceInCalendarDays } from 'date-fns';
import * as moment from 'moment';
import _ from 'lodash';

import { HouseStatusSettingService } from '@root/router/setting/custom-config/house-status-setting.service';
import { NoteV2Service } from '@root/router/component/note-v2/note-v2.service';
import { HouseStatusService } from '@root/router/house/house-status/house-status.service';
import { TranslateService } from '@root/shared/service/translate.service';
import { WritePermissionGurd } from '@root/util/decorator';
import { StoreService } from '@root/shared/service/store.service';
import { DateService } from '@root/shared/service/date.service';
import { InternationalService } from '@root/international.service';
import { OVERSEAS_EDITION_TIME_FORMAT, MAX_AMOUNT } from '@root/config';

enum TYPE {
  INCOME = 1,
  COST = -1,
}

interface File {
  url: string; // 图片url
  id: number; // 凭证id
}

@Component({
  selector: 'host-note-v2',
  templateUrl: './note-v2.component.html',
  styleUrls: ['./note-v2.component.scss'],
})
export class NoteV2Component implements OnInit {
  @Input() createOrEdit: 'edit' | 'create' = 'create';
  @Input() orderOrWhole: 'order' | 'whole' = 'whole';
  @Input() data;
  @Input() id;
  @Input() orderDetailCurrency;
  @Input() orderDetailCode;

  private readonly dateFormatKey = 'hostex-i18n-dateformat';
  private readonly timeFormatKey = 'hostex-i18n-timeformat';

  listOfOutcomeItem = [];
  listOfOutcomeMethod = [];
  listOfIncomeItem = [];
  listOfIncomeMethod = [];
  currencyList = ['CNY'];

  form: FormGroup = this.fb.group({
    type: [TYPE.INCOME, Validators.required],
    action_type: [22, Validators.required],
    currency_type: [
      this.internationalService.getCurrency() || 'CNY',
      Validators.required,
    ],
    amount: [null, Validators.required],
    action_date: null,
    payment_method: [null, Validators.required],
    month_share: null,
    shareChecked: 0,
    action_day: '01',
    action_time: null,
  });
  imageList: Array<File> = [];
  imageIds = [];
  note = null;
  checking = false;
  defaultOpenValue = new Date(0, 0, 0, 0, 0, 0);
  params = {
    type: null,
    action_type: null,
    currency_type: null,
    payment_method: null,
    amount: null,
    house_ids: null,
    month_share: null,
    action_date: null,
    note: null,
  };
  maxAmount = MAX_AMOUNT;
  currency = this.internationalService.getCurrency() || 'CNY';
  defaultHouses;
  defaultHouseTitle;
  checkedHouses = [];
  angularDateFormat = this.dateService.getAngularFormat(['YMD', 'hms']);
  angularTimeFormat = this.dateService.getAngularFormat([null, 'hms']);

  get listOfItemOption() {
    if (this.form.get('type').value === 1) {
      return this.listOfIncomeItem;
    } else {
      return this.listOfOutcomeItem;
    }
  }

  get listOfMethodOption() {
    if (this.form.get('type').value === 1) {
      return this.listOfIncomeMethod;
    } else {
      return this.listOfOutcomeMethod;
    }
  }

  get dayList() {
    const list = [];
    for (let i = 1; i <= 28; i++) {
      list.push({
        title: this.translateService.syncGet('component.note.day_in_month', {
          i,
        }),
        id: i < 10 ? `0${i}` : i,
      });
    }
    return list;
  }

  get amountPlaceHolder() {
    const type = this.form.get('type').value;
    return type === 1
      ? this.translateService.syncGet('component.note.income_amount')
      : this.translateService.syncGet('component.note.outcome_amount');
  }
  get use12Hours() {
    const timeFormat = this.dateService.getTimeFormat();
    return timeFormat === OVERSEAS_EDITION_TIME_FORMAT.HOUR_TWELVE
      ? true
      : false;
  }

  disabledTime = (current: Date): boolean => {
    const today = new Date();
    const diff = differenceInCalendarDays(current, today);
    return diff > 365 || diff < -365;
  };

  constructor(
    private fb: FormBuilder,
    private subject: NzModalRef,
    private noteService: NoteV2Service,
    private commonConfigService: HouseStatusSettingService,
    private modalService: NzModalService,
    private messageService: NzMessageService,
    private houseStatusService: HouseStatusService,
    private translateService: TranslateService,
    private dateService: DateService,
    private internationalService: InternationalService,
    private storeService: StoreService
  ) {}

  ngOnInit() {
    this.patchForm();
    this.fetchCommonConfig();
    this.getCurrencyForOrder();
    this.getCurrencyList();
    this.getExchangeRate();
  }

  patchForm() {
    if (this.createOrEdit === 'edit') {
      console.log(this.data);
      const date = _.get(this.data, 'action_date');
      this.form.patchValue({
        type: this.data.type === 0 ? -1 : this.data.type,
        action_type: _.get(this.data, 'action_type'),
        currency_type: this.data.currency_type,
        amount: _.get(this.data, 'amount'),
        action_date: moment(date).toDate(),
        payment_method: this.data.payment_method,
        month_share: null,
        shareChecked: 0,
      });
      this.note = this.data.note;
      const houseTemp = [];
      houseTemp.push(_.get(this.data, 'house.id'));
      this.defaultHouses = houseTemp;
      const title_alias = _.get(this.data, 'house.title_alias');
      const title = _.get(this.data, 'house.title');
      this.defaultHouseTitle = title_alias !== '' ? title_alias : title;
      this.checkedHouses.push(_.get(this.data, 'house.id'));
      _.forEach(this.data.invoice, (picture) => {
        this.imageList.push({
          id: picture.id,
          url: picture.url,
        });
        this.imageIds.push(picture.id);
      });
      console.log(this.imageList);
    } else {
      this.form.patchValue({
        action_date: moment().toDate(),
      });
    }
  }

  fetchCommonConfig() {
    this.commonConfigService.getSettings().subscribe((res) => {
      this.listOfIncomeMethod =
        _.filter(_.get(res, 'data.income_method'), { delete_time: null }) || [];
      this.listOfIncomeItem =
        _.filter(_.get(res, 'data.income_item'), { delete_time: null }) || [];
      this.listOfOutcomeMethod =
        _.filter(_.get(res, 'data.outcome_method'), { delete_time: null }) ||
        [];
      this.listOfOutcomeItem =
        _.filter(_.get(res, 'data.outcome_item'), { delete_time: null }) || [];
    });
  }

  getCurrencyForOrder() {
    if (this.data) {
      this.currency =
        _.get(this.data, 'currency_type') || _.get(this.data, 'currency');
      return;
    }
    if (this.orderDetailCurrency) {
      this.currency = this.orderDetailCurrency;
    }
  }

  getCurrencyList() {
    this.noteService.getCurrency().subscribe((res) => {
      if (res.error_code === 0) {
        this.currencyList = _.get(res, 'data.currency_list');
      }
    });
  }

  getExchangeRate() {
    const params = {
      from: 'CNY',
      to: this.currency,
    };
    this.houseStatusService.getExchangeRate(params).subscribe((res) => {
      if (res.error_code === 0) {
        this.maxAmount = Math.floor(this.maxAmount * _.get(res, 'data.quote'));
      }
    });
  }

  checkedHousesChange(house) {
    this.checkedHouses = _.map(house, 'id');
    this.defaultHouses = _.cloneDeep(this.checkedHouses);
  }

  chooseShareMonths(months) {
    const month_share = [];
    const range = _.get(months, 'range');
    month_share.push(range[0]);
    month_share.push(range[1]);
    this.form.patchValue({
      month_share: month_share,
    });
  }

  typeChange() {
    const value = this.form.get('type').value;
    // 记账，收入默认房费22，支出默认人工费用1
    this.form.patchValue({
      action_type: value === 1 ? 22 : 1,
      house_ids: null,
    });
    this.defaultHouses = null;
    this.defaultHouseTitle = null;
    this.checkedHouses = [];
    if (this.orderOrWhole === 'whole' && value === 1) {
      this.form.patchValue({
        shareChecked: 0,
      });
    }
  }

  fileChange(files) {
    this.imageList = files;
    this.imageIds = _.map(files, 'id');
  }

  @WritePermissionGurd('a_balance_of_payments')
  addNote() {
    this.checking = true;
    const valid = this.checkFormValid();
    if (!valid) {
      return;
    }
    if (this.createOrEdit === 'edit') {
      if (this.orderOrWhole === 'whole') {
        this.eidtWholeNote();
      } else {
        this.editOrderNote();
      }
    } else {
      if (this.orderOrWhole === 'whole') {
        this.addWholeNote();
      } else {
        this.addOrderNote();
      }
    }
  }

  eidtWholeNote() {
    const value = this.form.value;
    const params = {
      id: this.id,
      type: value.type,
      action_type: value.action_type,
      currency_type: value.currency_type,
      payment_method: value.payment_method,
      amount: value.amount,
      house_id: this.checkedHouses[0],
      invoice_ids: this.imageIds.length === 0 ? null : this.imageIds,
      action_date: moment(new Date(value.action_date)).format(
        'YYYY-MM-DD HH:mm:ss'
      ),
      note: this.note,
    };
    this.noteService.modifyTransaction(params).subscribe((res) => {
      if (res.error_code === 0) {
        const successText = this.translateService.syncGet(
          'success.modify_note'
        );
        this.messageService.success(successText);
        this.subject.destroy({
          refresh: true,
        });
      }
    });
  }

  addWholeNote() {
    const value = this.form.value;
    const action_date = moment(new Date(value.action_date)).format(
      'YYYY-MM-DD HH:mm:ss'
    );
    if (value.type === 1) {
      _.assign(this.params, {
        house_ids: this.checkedHouses,
        action_date: action_date,
        month_share: [],
      });
    } else {
      let date;
      if (value.shareChecked === 1) {
        const action_day = value.action_day;
        const action_time = moment(new Date(value.action_time)).format(
          'HH:mm:ss'
        );
        date = `${action_day} ${action_time}`;
      } else {
        date = moment(new Date(value.action_date)).format(
          'YYYY-MM-DD HH:mm:ss'
        );
      }
      _.assign(this.params, {
        action_date: date,
        house_ids: this.checkedHouses,
        month_share: !value.shareChecked ? [] : value.month_share,
      });
    }
    _.assign(this.params, {
      type: value.type,
      action_type: value.action_type,
      currency_type: value.currency_type,
      payment_method: value.payment_method,
      amount: value.amount,
      note: this.note,
      invoice_ids: this.imageIds.length === 0 ? null : this.imageIds,
    });
    this.noteService.addNoteV2(this.params).subscribe((res) => {
      if (res && res.error_code === 0) {
        this.noteService.addNoteChange('true');
        const successtext = this.translateService.syncGet('success.add_note');
        this.messageService.success(successtext);
        this.subject.destroy();
      }
    });
  }

  editOrderNote() {
    const value = this.form.value;
    const params = {
      transaction_id: this.id,
      action_type: value.action_type,
      payment_method: value.payment_method,
      amount: value.amount,
      action_time: moment(new Date(value.action_date)).format(
        'YYYY-MM-DD HH:mm:ss'
      ),
      type: value.type,
      invoice_ids: this.imageIds.length === 0 ? null : this.imageIds,
      note: this.note,
      format: 'v_2',
    };
    this.noteService.modifyReservationNote(params).subscribe((res) => {
      if (res.error_code === 0) {
        this.subject.destroy({
          refresh: true,
        });
      }
    });
  }

  addOrderNote() {
    const value = this.form.value;
    const params = {
      reservation_code: this.orderDetailCode,
      action_type: value.action_type,
      payment_method: value.payment_method,
      amount: value.amount,
      action_time: moment(new Date(value.action_date)).format(
        'YYYY-MM-DD HH:mm:ss'
      ),
      type: value.type,
      invoice_ids: this.imageIds.length === 0 ? null : this.imageIds,
      note: this.note,
      format: 'v_2',
    };
    this.noteService.addReservationNote(params).subscribe((res) => {
      if (res.error_code === 0) {
        this.subject.destroy({
          refresh: true,
        });
      }
    });
  }

  // actionDateChange(date) {
  //   const formattedDate = this.dateService.format(date, ['YMD', 'hms']);
  //   this.form.patchValue({
  //     action_date: formattedDate
  //   });
  // }

  checkFormValid() {
    const value = this.form.value;
    const amount = value.amount;
    if (!amount || value.amount === '') {
      return false;
    }
    if (
      value.shareChecked === 1 &&
      (!value.month_share || !value.action_time)
    ) {
      return false;
    }
    if (value.payment_method === null) {
      return false;
    }
    return true;
  }

  cancel() {
    this.subject.destroy('onCancel');
  }
}
